export const addresses = {
  providerAddress: "0x95D17E39e79b07bE36865831816B0Fac2c234708",
};
